import { Box, Card, CardContent, Typography } from '@mui/material'
import TotalTransactionFeesChart from './TotalTransactionFeesChart'
import { useRouteQuery } from '@/hooks/useRouteQuery'

export const MainStatisticChartCard = ({ data, dataCompare }: { data: any; dataCompare: any }) => {
  const { __, __n } = useTranslator()
  const { searchQuery } = useRouteQuery()

  const chartData = data ? Object.values(data).map((item: any) => item?.balance?.service_fee) : []
  const month = searchQuery.get('month')?.substring(5, 7)

  return (
    <Card className='rounded-[16px]'>
      <CardContent className='p-6'>
        <div className='flex flex-col gap-2'>
          <div className='flex flex-row gap-2 items-center'>
            <Box className='rounded-[6px] bg-[#DFE3FD] p-2 flex items-center '>
              <i className='tabler-wallet text-[#3551F2]'></i>
            </Box>
            <Typography className='text-[18px] font-medium leading-[28px]'>{__('Total Transaction Fees')}</Typography>
          </div>
          <Typography className='text-[38px] font-medium leading-[56px]'>
            {__n(chartData[Number(month) - 1], 'đ')}
          </Typography>
          <Typography className='text-[13px] font-normal leading-[20px] '>
            {__('This month’s update compared to last month')}
          </Typography>
        </div>

        {/* Chart Total Transaction Fees */}
        <TotalTransactionFeesChart className='h-[300px] mb-3' data={chartData} activeIndex={Number(month) - 1} />

        <div className='grid grid-cols-1 md:grid-cols-3 gap-6 p-5 border rounded-[6px]'>
          <div className='flex flex-col gap-2'>
            <div className='flex flex-row gap-2 items-center'>
              <Box className='flex items-center rounded-[6px] bg-[#FDF0E1] p-2 '>
                <i className='tabler-clipboard-list text-[#FF9F43]'></i>
              </Box>
              <Typography className='text-[15px] font-normal leading-[24px]'>{__('Requested Transactions')}</Typography>
            </div>
            <Typography className='text-[24px] font-medium leading-[38px]'>{__n(dataCompare?.request_num)}</Typography>
          </div>
          <div className='flex flex-col gap-2'>
            <div className='flex flex-row gap-2 items-center'>
              <Box className='flex items-center rounded-[6px] bg-[#DDF6E8] p-2 '>
                <i className='tabler-checkup-list text-[#28C76F]'></i>
              </Box>
              <Typography className='text-[15px] font-normal leading-[24px]'>{__('Total EWA Disbursement')}</Typography>
            </div>
            <Typography className='text-[24px] font-medium leading-[38px]'>
              {__n(dataCompare?.debt_disbursement, 'đ')}
            </Typography>
          </div>
          <div className='flex flex-col gap-2'>
            <div className='flex flex-row gap-2 items-center'>
              <Box className='flex items-center rounded-[6px] bg-[#D6F4F8] p-2 '>
                <i className='tabler-chart-pie-2 text-[#00BAD1]'></i>
              </Box>
              <Typography className='text-[15px] font-normal leading-[24px]'>
                {__('Est. Max EWA Disbursement')}
              </Typography>
            </div>
            <Typography className='text-[24px] font-medium leading-[38px]'>
              {__n(dataCompare?.eligibility_amount, 'đ')}
            </Typography>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
